<template>
  <b-nav-item-dropdown no-caret class="user_infos">
    <!-- Using button-content slot -->
    <template slot="button-content">
      <div>
        <font-awesome-icon class="icon" icon="user" />
        <p>{{ userName }}</p>
      </div>
    </template>
    <router-link to="/user/infos" class="dropdown-item">
      <span>Mes informations</span>
    </router-link>
    <router-link to="/user/cases" class="dropdown-item">
      <span>Mes dossiers</span>
    </router-link>
    <router-link to="/user/account" class="dropdown-item">
      <span>Mon compte</span>
    </router-link>
    <b-dropdown-divider></b-dropdown-divider>
    <router-link to="/reports" :event="''" @click.native.prevent="logout" class="dropdown-item">
      <span>Déconnexion</span>
    </router-link>
  </b-nav-item-dropdown>
</template>

<script>
import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown'

export default {
  name: 'app-navbar-menu',
  components: {
    bNavItemDropdown
  },
  props: {
    userName: String
  },
  methods: {
    logout () {
      this.$emit('logout')
    }
  }
}
</script>

<style scoped>

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .user_infos {
    min-width: 230px;
    max-width: 230px;
    margin-left: 50%;
  }

  a.nav-link > div {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/app-navbar-user.vue